import { useState } from 'react'

export type AccordionSection = 'overview' | 'duration' | 'aiUsage' | 'daily' | 'weekly' | 'medicalActs' | 'entityEvolution'

export const useAccordionState = (defaultExpanded: AccordionSection | false = 'overview') => {
  const [expandedSection, setExpandedSection] = useState<AccordionSection | false>(defaultExpanded)

  const handleAccordionChange = (panel: AccordionSection) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpandedSection(isExpanded ? panel : false)
  }

  const isExpanded = (section: AccordionSection) => expandedSection === section

  return {
    expandedSection,
    setExpandedSection,
    handleAccordionChange,
    isExpanded,
  }
}
